module.exports = __webpack_public_path__ + "img/thumbnail_Cassowary_m_normal.7dbcbfe1.png";